/**
 * Returns a list with stopwords for the Dutch passive voice assessment.
 * @returns {Array} The list with stopwords.
 */
export default function() {
	return [
		"alhoewel",
		"als",
		"dan",
		"doordat",
		"hoewel",
		"hoezeer",
		"indien",
		"mits",
		"naargelang",
		"naarmate",
		"nadat",
		"ofschoon",
		"omdat",
		"opdat",
		"tenzij",
		"toen",
		"voordat",
		"voorzover",
		"wanneer",
		"zoals",
		"zodat",
		"zodra",
		"zolang",
		"wie",
		"wiens",
		"wier",
		"welke",
		"welk",
	];
}
